<template>
  <div class="tpp-page">
    <zhuomuniao-ops-nav active-path="/pages/tpp/zhuomuniao/catalog" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">服务目录</h2>
          <p class="tpp-muted">对方没有商品查询接口。分类和商品详情将后续手工导入；本页只读已有映射，不在此编辑详情。</p>
        </div>
        <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
      </div>
      <el-alert title="后续导入将包含分类、封面、介绍、服务范围、须知与预付价。当前不要用通用 TPP 商品页给用户端供货。" type="info" :closable="false" show-icon />
      <div class="tpp-filter" style="margin-top:12px">
        <el-input v-model.trim="filters.name" placeholder="产品名称" clearable style="width:180px" @keyup.enter.native="search" />
        <el-input v-model.trim="filters.externalProductId" placeholder="对方产品 ID" clearable style="width:160px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
    </section>
    <section class="tpp-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="name" label="产品名称" min-width="160" />
        <el-table-column prop="externalProductId" label="对方产品 ID" width="130" />
        <el-table-column prop="catalogName" label="分类" width="120">
          <template slot-scope="scope">{{ scope.row.catalogName || '待导入' }}</template>
        </el-table-column>
        <el-table-column label="预付价" width="120">
          <template slot-scope="scope">{{ scope.row.prepayAmount || '-' }} / {{ scope.row.priceUnit || '次' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === '1002' ? 'success' : 'info'" size="small">{{ scope.row.state === '1002' ? '上架' : '未上架' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
      </el-table>
      <p v-if="!loading && !rows.length" class="tpp-muted" style="margin-top:12px">暂无产品。分类和详情待手工导入后再发布到小区。</p>
      <el-pagination class="tpp-pagination" :current-page.sync="page.current" :page-size="page.size" :total="page.total"
        layout="total, prev, pager, next" @current-change="load" />
    </section>
    <section class="tpp-panel">
      <div class="tpp-panel__head"><h3 class="tpp-panel__title">小区发布（只读）</h3></div>
      <p class="tpp-tip">用户端只读 state=1002 且属于当前小区的发布记录。产品导入完成后再开放发布编辑。</p>
      <el-table v-loading="pubLoading" :data="publications" border>
        <el-table-column prop="productName" label="产品" min-width="160" />
        <el-table-column label="小区" min-width="140">
          <template slot-scope="scope">{{ scope.row.communityName || scope.row.communityId || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === '1002' ? 'success' : 'info'" size="small">{{ scope.row.state === '1002' ? '已发布' : '未发布' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始" width="170" />
        <el-table-column prop="endTime" label="结束" width="170" />
      </el-table>
    </section>
  </div>
</template>
<script>
import ZhuomuniaoOpsNav from './zhuomuniaoNav.vue'
import { zhuomuniaoOpsMixin } from './zhuomuniaoOpsMixin'
import { listProducts, listPublications } from '@/api/life/homeServiceApi'
import { zmnTotal } from '@/api/tpp/zhuomuniaoOpsApi'
import '../tpp.scss'
export default {
  name: 'ZhuomuniaoCatalog',
  components: { ZhuomuniaoOpsNav },
  mixins: [zhuomuniaoOpsMixin],
  data() {
    return {
      loading: false, pubLoading: false, rows: [], publications: [],
      filters: { name: '', externalProductId: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  async created() { if (await this.ensureZhuomuniaoPlatform()) { this.load(); this.loadPublications() } },
  methods: {
    search() { this.page.current = 1; this.load() },
    async load() {
      this.loading = true
      try {
        const res = await listProducts({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = zmnTotal(res)
      } catch (e) { this.rows = []; this.page.total = 0; this.$message.error(e.message || '目录加载失败') }
      finally { this.loading = false }
    },
    async loadPublications() {
      this.pubLoading = true
      try {
        const res = await listPublications({ page: 1, row: 50 })
        this.publications = res.data || []
      } catch (e) { this.publications = [] }
      finally { this.pubLoading = false }
    }
  }
}
</script>
